module.exports = __webpack_public_path__ + "img/loginApp.4f78d076.png";